import { AuthGuard } from '../../app.authGuard';
import { RunGuardsAndResolvers, Route } from '@angular/router';

import { WebkessLayoutComponent } from './webkess-layout/webkess-layout.component';
import { WebkessSettingsComponent } from './webkess-settings/webkess-settings.component';
import { ExportToWebKessComponent } from './export-to-web-kess/export-to-web-kess.component';
import { WebkessReportComponent } from './webkess-report/webkess-report.component';


const options = {
  runGuardsAndResolvers: 'always' as RunGuardsAndResolvers
};

export let WebKessManageRouterModule: Route = {
  path: 'institution/webKess/:id/:packageId', component: WebkessLayoutComponent, children: [
    { path: 'webKessSettings', component: WebkessSettingsComponent, canActivate: [AuthGuard] },
    { path: 'exportWebKess', component: ExportToWebKessComponent, canActivate: [AuthGuard] },
    { path: 'webKessReports', component: WebkessReportComponent, canActivate: [AuthGuard] },
    { path: '', redirectTo: 'webKessSettings', pathMatch: 'full', canActivate: [AuthGuard] },
    { path: '**', redirectTo: 'webKessSettings', canActivate: [AuthGuard] }
  ]
};

